// Generated from angular.template.env — DO NOT EDIT.
// Edit libs/env/staging/ source files and run pnpm env:generate staging.
import type { Environment } from '@vasta/env';

export const environment: Environment = {
  "production": false,
  "apiBaseUrl": "/api",
  "zitadelIssuer": "https://auth.staging.turn-up.it",
  "zitadelClientId": "395068543344836613",
  "clientAppUrl": "https://app.staging.turn-up.it"
};
